import { FileLink } from '@/components/portal/file-link';
import type { InboxItem } from '@/lib/portal';
import { INBOX_KIND_LABEL } from '@/lib/portal';
import { formatDateTime } from '@/lib/format';

/** The upload a bill or expense is being created from, beside the form (document inbox). */
export function InboxSource({ item }: { item: InboxItem }) {
  return (
    <div
      className="flex flex-wrap items-center gap-x-4 gap-y-1 rounded-md border border-primary/30 bg-primary/5 px-3 py-2 text-sm"
      data-testid="inbox-source"
    >
      <span className="font-medium">From the document inbox:</span>
      <FileLink file={item.file} />
      <span className="text-muted-foreground">
        {INBOX_KIND_LABEL[item.kind]} uploaded by {item.uploadedBy ?? 'someone'} on{' '}
        {formatDateTime(item.uploadedAt)}
        {item.note ? ` · “${item.note}”` : ''}
      </span>
      <span className="text-muted-foreground">
        Saving keeps the file attached and marks the upload recorded.
      </span>
    </div>
  );
}
